module.exports = __webpack_public_path__ + "img/Layer_1.fcd298c0.png";